import React from "react";
import Shimmer from "@techsoftware/happay-widgets/Shimmer";

export default class CustomShimmer extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { width, height, className, shimmerStyle } = this.props;
        return (
            <Shimmer
                {...this.props}
                width={width}
                height={height}
                className={className}
                shimmerStyle={shimmerStyle}
            />
        );
    }
}
